import { render, staticRenderFns } from "./dataGoodsSale.vue?vue&type=template&id=6d25de8e&scoped=true"
import script from "./dataGoodsSale.vue?vue&type=script&lang=js"
export * from "./dataGoodsSale.vue?vue&type=script&lang=js"
import style0 from "./dataGoodsSale.vue?vue&type=style&index=0&id=6d25de8e&prod&lang=less&scoped=true"
import style1 from "./dataGoodsSale.vue?vue&type=style&index=1&id=6d25de8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d25de8e",
  null
  
)

export default component.exports